<!-- https://8es9hr.axshare.com/#g=1&p=%E7%9B%B8%E9%97%9C%E5%82%B3%E7%A5%A8_1 -->
<!-- 相關傳票 -->
<template>
  <div class="row" v-if="$route.meta.subFormKeepAlive">
    <div class="col-12">
      <div class="col-block">
        <div class="block-header has-border">
          <h3>
            <strong>相關傳票</strong>
          </h3>
          <el-button
            type="primary"
            class="ml10"
            plain
            v-if="button.effectiveVoucher"
            @click="openDialog(1)"
            >開立生效傳票</el-button
          >
          <el-button
            type="primary"
            class="ml10"
            plain
            v-if="button.disEffectiveVoucher"
            @click="openDialog(2)"
            >開立到期解約傳票</el-button
          >
          <el-button
            type="primary"
            class="ml10"
            plain
            v-if="button.earlyDisEffectiveVoucher"
            @click="openDialog(3)"
            >開立中途解約傳票</el-button
          >
          <el-button
            type="primary"
            class="ml10"
            plain
            v-if="button.reNew"
            @click="go('deposit_order_summons_continue')"
            >續存作業</el-button
          >
        </div>
        <div class="block-content">
          <table class="table table-bordered mb-0">
            <thead class="grey lighten-4">
              <tr>
                <th>收款日期</th>
                <th>科目代號</th>
                <th>科目名稱</th>
                <th>借方金額</th>
                <th>貸方金額</th>
                <th>摘要</th>
              </tr>
            </thead>
            <tbody v-if="recordToEdit.length > 0">
              <template v-for="(row, idx) in recordToEdit">
                <tr>
                  <td :rowspan="row.details.length">
                    {{ $transferDate(row.main.tradeDate) }}
                  </td>
                  <td>{{ row.details[0].accountTitleCode }}</td>
                  <td>{{ row.details[0].accountTitleName }}</td>
                  <td>{{ $addcomma(row.details[0].debitAmount) }}</td>
                  <td>{{ $addcomma(row.details[0].creditAmount) }}</td>
                  <td>{{ row.details[0].summary }}</td>
                </tr>
                <tr v-for="(detail, idx) in row.details.slice(1)">
                  <td>{{ detail.accountTitleCode }}</td>
                  <td>{{ detail.accountTitleName }}</td>
                  <td>
                    {{ $addcomma(detail.debitAmount) }}
                  </td>
                  <td>{{ $addcomma(detail.creditAmount) }}</td>
                  <td>{{ detail.summary }}</td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6" class="center">暫無資料</td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-dialog
          :title="dialogTitle[dialogType]"
          :visible.sync="dialogAddItem"
          :append-to-body="true"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          width="800px"
        >
          <p style="font-size: 16px" v-if="dialogType == 2 || dialogType == 3">
            請輸入利息金額
            <el-input
              style="width: 200px"
              class="ml10"
              v-model="interestAmount"
              @change="getVoucher('disEffectiveVoucher')"
              v-if="dialogType == 2"
            ></el-input>
            <el-input
              style="width: 200px"
              class="ml10"
              v-model="interestAmount"
              @change="getVoucher('earlyDisEffectiveVoucher')"
              v-if="dialogType == 3"
            ></el-input>
          </p>
          <table class="table table-bordered mb-0" v-if="dialogType != 3" v-loading="templateLoading">
            <thead class="grey lighten-4 text-nowrap">
              <tr>
                <th>收款日期</th>
                <th>科目代號</th>
                <th>科目名稱</th>
                <th>借方金額</th>
                <th>貸方金額</th>
                <th>摘要</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td :rowspan="currentEdit.details.length" class="text-nowrap">
                  {{ $transferDate(currentEdit.main.tradeDate) }}
                </td>
                <td>{{ currentEdit.details[0].accountTitleCode }}</td>
                <td>{{ currentEdit.details[0].accountTitleName }}</td>
                <td>
                  {{
                    $addcomma(
                      Number(
                        currentEdit.details[0].debitAmount +
                          Number($removeComma(interestAmount))
                      )
                    )
                  }}
                </td>
                <!-- <td>{{calculateAmout(currentEdit.details[0].debitAmount)}}</td> -->
                <td>{{ currentEdit.details[0].creditAmount }}</td>
                <td>
                  <el-input v-model="currentEdit.details[0].summary"></el-input>
                </td>
              </tr>
              <tr v-for="(detail, idx) in currentEdit.details.slice(1)">
                <td>{{ detail.accountTitleCode }}</td>
                <td>{{ detail.accountTitleName }}</td>
                <td>{{ $addcomma(detail.debitAmount) }}</td>
                <td>{{ $addcomma(detail.creditAmount) }}</td>
                <td>
                  <el-input v-model="detail.summary"></el-input>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="dialogType == 3" v-loading="templateLoading">
            <el-radio
              v-model="earlyDisEffectiveVoucher"
              label="expiringInterest"
              >中途解約(未扣回利息)(到期付息)</el-radio
            >
            <table class="table table-bordered mb-0">
              <thead class="grey lighten-4 text-nowrap">
                <tr>
                  <th>收款日期</th>
                  <th>科目代號</th>
                  <th>科目名稱</th>
                  <th>借方金額</th>
                  <th>貸方金額</th>
                  <th>摘要</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td :rowspan="currentEdit.expiringInterest.details.length" class="text-nowrap">
                    {{ $transferDate(currentEdit.expiringInterest.main.tradeDate) }}
                  </td>
                  <td>
                    {{ currentEdit.expiringInterest.details[0].accountTitleCode }}
                  </td>
                  <td>
                    {{ currentEdit.expiringInterest.details[0].accountTitleName }}
                  </td>
                  <td>
                    {{ $addcomma(currentEdit.expiringInterest.details[0].debitAmount) }}
                  </td>
                  <td>
                    {{ $addcomma(currentEdit.expiringInterest.details[0].creditAmount) }}
                  </td>
                  <td>
                    <el-input
                      v-model="currentEdit.expiringInterest.details[0].summary"
                    ></el-input>
                  </td>
                </tr>
                <tr
                  v-for="(detail, idx) in currentEdit.expiringInterest.details.slice(1)"
                >
                  <td>{{ detail.accountTitleCode }}</td>
                  <td>{{ detail.accountTitleName }}</td>
                  <td>{{ $addcomma(detail.debitAmount) }}</td>
                  <td>{{ $addcomma(detail.creditAmount) }}</td>
                  <td>
                    <el-input v-model="detail.summary"></el-input>
                  </td>
                </tr>
              </tbody>
            </table>
            <el-radio v-model="earlyDisEffectiveVoucher" label="monthlyInterest"
              >中途解約(扣回利息)(每月付息)</el-radio
            >
            <table class="table table-bordered mb-0">
              <thead class="grey lighten-4 text-nowrap">
                <tr>
                  <th>收款日期</th>
                  <th>科目代號</th>
                  <th>科目名稱</th>
                  <th>借方金額</th>
                  <th>貸方金額</th>
                  <th>摘要</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td :rowspan="currentEdit.monthlyInterest.details.length" class="text-nowrap">
                    {{
                      $transferDate(currentEdit.monthlyInterest.main.tradeDate)
                    }}
                  </td>
                  <td>
                    {{
                      currentEdit.monthlyInterest.details[0].accountTitleCode
                    }}
                  </td>
                  <td>
                    {{
                      currentEdit.monthlyInterest.details[0].accountTitleName
                    }}
                  </td>
                  <td>
                    {{
                      $addcomma(
                        currentEdit.monthlyInterest.details[0].debitAmount
                      )
                    }}
                  </td>
                  <td>
                    {{
                      $addcomma(
                        currentEdit.monthlyInterest.details[0].creditAmount
                      )
                    }}
                  </td>
                  <td>
                    <el-input
                      v-model="currentEdit.monthlyInterest.details[0].summary"
                    ></el-input>
                  </td>
                </tr>
                <tr
                  v-for="(detail, idx) in currentEdit.monthlyInterest.details.slice(1)"
                >
                  <td>{{ detail.accountTitleCode }}</td>
                  <td>{{ detail.accountTitleName }}</td>
                  <td>{{ $addcomma(detail.debitAmount) }}</td>
                  <td>{{ $addcomma(detail.creditAmount) }}</td>
                  <td>
                    <el-input v-model="detail.summary"></el-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogAddItem = false">取消</el-button>
            <el-button type="primary" :disabled="templateLoading" @click="saveData">
              {{ templateLoading ? "載入中..." : "產生傳票" }}
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
  <router-view v-else></router-view>
</template>
<script>
import { API } from "@/assets/config";

export default {
  name: "deposit_order_summons",
  data() {
    return {
      id: this.$route.params.id,
      templateLoading: false,
      // 各開立按鈕是否顯示，由後端判定；取得前一律不顯示，避免閃一下才消失
      button: {
        effectiveVoucher: false,
        disEffectiveVoucher: false,
        earlyDisEffectiveVoucher: false,
        reNew: false,
      },
      recordToEdit: [],
      currentEdit: this.getDefaultEdit(),
      dialogType: 1,
      dialogTitle: ["", "開立生效傳票", "開立到期解約傳票", "開立中途解約傳票"],
      dialogAddItem: false,
      interestAmount: 0,
      // 中途解約傳票 radio
      earlyDisEffectiveVoucher: "",
    };
  },
  created() {
    this.getData();
  },
  computed: {
    data() {
      // 開立到期解約傳票
      const interestAmountNum = Number(String(this.interestAmount).replace(/,/g, "")) || 0;

      return this.currentEdit.details.map((item, idx) => {
        if (interestAmountNum !== 0 && idx === 0) {
          return {
            ...item,
            debitAmount: (item.debitAmount || 0) + interestAmountNum,
          };
        }
        return item;
      });
    },
    data2() {
      // 開立中途解約傳票
      let interestData = [];
      if (this.earlyDisEffectiveVoucher === "expiringInterest") {
        interestData = this.currentEdit.expiringInterest.details;
      }
      else if (this.earlyDisEffectiveVoucher === "monthlyInterest") {
        interestData = this.currentEdit.monthlyInterest.details;
      }
      return interestData;
    },
  },
  watch: {},
  methods: {
    getDefaultEdit() {
      return {
        main: {
          tradeDate: "",
          voucherCode: "",
          note: "",
          createTime: "",
          createName: "",
        },
        details: [{}],
        expiringInterest: {
          main: {
            tradeDate: "",
            voucherCode: "",
            note: "",
            createTime: "",
            createName: "",
          },
          details: [{}],
        },
        monthlyInterest: {
          main: {
            tradeDate: "",
            voucherCode: "",
            note: "",
            createTime: "",
            createName: "",
          },
          details: [{}],
        },
      };
    },
    async getData() {
      const url = API.coopNtDepositOrder + `?action=voucherList&id=${this.id}`;
      try {
        const json = await this.mAxiosGet(url);
        
        // 傳票是陣列，直接整包換掉；用物件展開會變成 {0:…,1:…} 沒有 length，畫面會判成無資料
        this.recordToEdit = json.resultData.data || [];
        this.button = { ...this.button, ...json.resultData.button };
      } catch (error) {
        console.error("Failed getData", error);
      }
    },
    openDialog(type) {
      // 重置資料
      this.interestAmount = 0;
      this.dialogAddItem = true;
      this.dialogType = type;
      this.currentEdit = this.getDefaultEdit();
      if (type == 1) {
        // 開立生效傳票
        this.getVoucher("effectiveVoucher");
      } else if (type == 2) {
        // 開立到期解約傳票
        this.getVoucher("disEffectiveVoucher");
      } else if (type == 3) {
        // 開立中途解約傳票
        this.getVoucher("earlyDisEffectiveVoucher");
      }
    },
    async getVoucher(action) {
      let url = API.coopNtDepositOrder + `?action=${action}&id=${this.id}`;
      if (action != "effectiveVoucher") {
        // 開立到期解約傳票 開立中途解約傳票
        url += `&interestAmount=${this.$removeComma(this.interestAmount) || 0}`;
      }

      this.templateLoading = true;
      try {
        const json = await this.mAxiosGet(url);
        this.currentEdit = { ...this.currentEdit, ...json.resultData };
      } catch (error) {
        console.error(error);
        this.$message.error("取得樣板失敗，請重試");
      } finally {
        this.templateLoading = false;
      }
    },
    async saveData() {
      if (this.earlyDisEffectiveVoucher === "" && this.dialogType == 3) {
        this.$message.error("請選擇為到期付息或每月付息");
        return;
      }
      const form = new FormData();
      var url = API.coopNtDepositOrder;
      var object;

      if (this.dialogType == 1) {
        // 開立生效傳票
        url += "?action=createEffectiveVoucher";
      } else if (this.dialogType == 2) {
        // 開立到期解約傳票
        url += "?action=createDisEffectiveVoucher";
      } else if (this.dialogType == 3) {
        // 開立中途解約傳票
        url += "?action=createEarlyDisEffectiveVoucher";
      }

      form.append("depositOrderId", this.id);

      if (this.dialogType == 3) {
        // 中途解約傳票
        object = this.currentEdit[this.earlyDisEffectiveVoucher].main;
        form.append(
          "detail",
          JSON.stringify(this.data2) || ""
        );
      } else {
        object = this.currentEdit.main;
        form.append("detail", JSON.stringify(this.data) || "");
      }

      Object.keys(object).map(function (objectKey, index) {
        var value = object[objectKey];
        form.append(objectKey, value !== undefined ? value : "");
      });

      try {
        await this.mAxiosPost(url, form);
        this.showAjaxSuccessMsg();
        this.getData();
        this.dialogAddItem = false;
      } catch (error) {
        console.error("Failed saveData", error);
      }
    },
    go(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>